import { Button, Group, Modal, Select, Stack, TextInput } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { ScheduleDisplayModeValues } from 'modules/schedules/consts'
import { useScheduleMutations } from 'modules/schedules/mutations.hooks'
import {
  ALL_SCHEDULES,
  NORMALIZED_SHIFTS_FROM_RANGE_QUERY,
  SCHEDULE_QUERY,
} from 'modules/schedules/queries'
import { ScheduleNode } from 'modules/schedules/types.graphql'
import { useState } from 'react'

interface ScheduleSettingsModalProps {
  isOpen: boolean
  schedule: Pick<ScheduleNode, 'id' | 'name' | 'displayMode'>
  onCloseCallback: () => void
}

export const ScheduleSettingsModal: React.FC<ScheduleSettingsModalProps> = ({
  isOpen,
  schedule,
  onCloseCallback,
}) => {
  const [name, setName] = useState(schedule.name)
  const [displayMode, setDisplayMode] = useState(schedule.displayMode)

  const { patchSchedule } = useScheduleMutations()

  function handleSave() {
    patchSchedule({
      variables: {
        id: schedule.id,
        input: {
          name,
          displayMode,
        },
      },
      refetchQueries: [
        ALL_SCHEDULES,
        SCHEDULE_QUERY,
        NORMALIZED_SHIFTS_FROM_RANGE_QUERY,
      ],
      onCompleted() {
        showNotification({
          title: 'Suksess',
          message: 'Vaktplanen ble oppdatert',
          color: 'green',
        })
        onCloseCallback()
      },
      onError({ message }) {
        showNotification({
          title: 'Noe gikk galt',
          message,
          color: 'red',
        })
      },
    })
  }

  return (
    <Modal
      title="Innstillinger vaktplan"
      opened={isOpen}
      onClose={onCloseCallback}
    >
      <Stack>
        <TextInput value={name} onChange={evt => setName(evt.target.value)} />
        <Select
          value={displayMode}
          clearable={false}
          label="Visningsmodus"
          data={[
            {
              value: ScheduleDisplayModeValues.SINGLE_LOCATION,
              label: 'Ett lokale',
            },
            {
              value: ScheduleDisplayModeValues.MULTIPLE_LOCATIONS,
              label: 'Flere lokaler',
            },
          ]}
          onChange={evt => setDisplayMode(evt as ScheduleDisplayModeValues)}
        />

        <Group justify="flex-end">
          <Button color="gray" onClick={onCloseCallback}>
            Avbryt
          </Button>
          <Button color="samfundet-red" onClick={handleSave}>
            Lagre
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
